import { EntityCreateResponse } from '@faro/http-clients';
import { CommandResponse, Cycle, RevisionedCommandResponse, StudyEntity, toCycle } from '@faro/study-designer-model';
import axios from 'axios';
import { Identifiable } from 'faro-common-model';
import { EpochConfigurationQueryParameters } from '../EpochConfiguration/EpochConfigurationClient';
import { RevisionQueryParameter, StudyPathParameter } from '../parameter';

export type CyclePathParameter = StudyPathParameter;
export type CycleQueryParameters = EpochConfigurationQueryParameters & RevisionQueryParameter;

/**
 * Client managing API for the {@link Cycle} entity
 */
export const cycleClient = {
    list: async (request?: CyclePathParameter & CycleQueryParameters, signal?: AbortSignal): Promise<Cycle[]> => {
        const { studyId, ...query } = request ?? {};
        return axios
            .get(`/api/study-designer/studies/${studyId}/cycles`, {
                signal,
                params: query,
            })
            .then(response => response.data?.map(toCycle) ?? []);
    },

    // TODO: when service will be removed, it should use RevisionedCommandResponse<EntityCommandCreateResponse> from @faro/study-designer-model instead of EntityCreateResponse
    create: async (entity: Cycle, signal?: AbortSignal): Promise<EntityCreateResponse> => {
        return axios
            .post(`/api/study-designer/studies/${entity.studyId}/cycles`, entity, {
                signal,
            })
            .then(response => ({
                id: response.data.entityId,
                revision: response.data.revision,
            }));
    },

    update: async (entity: Cycle, signal?: AbortSignal): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .put(`/api/study-designer/studies/${entity.studyId}/cycles/${entity.id}`, entity, { signal })
            .then(response => response.data);
    },

    delete: async (entity: StudyEntity, signal?: AbortSignal): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .delete(`/api/study-designer/studies/${entity.studyId}/cycles/${entity.id}`, { signal })
            .then(response => response.data);
    },

    get: async (request: CyclePathParameter & Identifiable, signal?: AbortSignal): Promise<Cycle> => {
        const { studyId, id } = request;
        return axios
            .get(`/api/study-designer/studies/${studyId}/cycles/${id}`, {
                signal,
            })
            .then(response => toCycle(response.data));
    },

    map: toCycle,
};
